import { ScenarioBuilderClient } from "@/pages/scenario-builder/api/client/scenarioClient";

type DuplicateScenarioV2Params = {
  scenarioBuilderClient: ScenarioBuilderClient;
  scenarioUuid: string;
};

export const duplicateScenarioV2 = ({
  scenarioBuilderClient,
  scenarioUuid,
}: DuplicateScenarioV2Params) => {
  return scenarioBuilderClient.scenarios.cloneScenario({
    scenarioUuid,
  });
};
